const stickyHeader = {
  header: document.getElementById('jsStickyHeader') as HTMLElement,
  mainContent: document.getElementById('main-content') as HTMLElement,
  line: document.getElementById('jsCartLine') as HTMLElement,
  lineWrap: document.getElementById('jsLineWrap') as HTMLElement,
  popups: document.querySelectorAll(
    '.jsStickyPopup',
  ) as NodeListOf<HTMLElement>,
  lastScrollTop: 0,

  init() {
    this.setClass();
    this.reset();
  },

  
  reset() {
    window.addEventListener('reset', () => {

      // document.addEventListener('scroll', () => {
      //   if(window.scrollY > 250) {
      //     if(this.lineWrap) {
      //       this.lineWrap.classList.add('activeClass');
      //     }
      //   } else {
      //     this.lineWrap.classList.remove('activeClass');
      //   }
      // });

    })
  },



  setClass() {
    document.addEventListener('scroll', () => {
      const st = window.scrollY || document.documentElement.scrollTop;
      if (st > this.lastScrollTop) {
        this.header.classList.remove('up');
        this.header.classList.add('down');
        this.mainContent.classList.remove('up');
        this.mainContent.classList.add('down');
        this.popups.forEach((popup) => {
          popup.classList.add('activeScroll');
        });

      } else {
        this.header.classList.add('up');
        this.header.classList.remove('down');
        this.mainContent.classList.add('up');
        this.mainContent.classList.remove('down');
        this.popups.forEach((popup) => {
          popup.classList.add('activeScroll');
        });

      }
      this.lastScrollTop = st <= 0 ? 0 : st;

      if (window.scrollY === 0) {
        this.header.classList.remove('up');
        this.header.classList.remove('down');
        this.mainContent.classList.remove('up');
        this.mainContent.classList.remove('down');
        // if(this.line) {
        // this.line.classList.remove('activeClass');
        // }
        this.popups.forEach((popup) => {
          popup.classList.remove('activeScroll');
        });
      }

      // if(window.scrollY > 250) {
      //   if(this.line) {
      //   this.line.classList.add('activeClass'); 
      //   }
      // }
    });
  },
};

export default stickyHeader;
